import { FC } from 'react';

const ExternalLayout: FC = ({ children }) => {
  return (
    <div className="h-screen w-screen flex flex-col">
      <div className="flex h-full">
        <div className="w-full flex-1 min-w-0 font-lato h-full">
          <div className="flex h-full">
            <div className="w-full h-full">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ExternalLayout };
